import React, { useState, useRef, useCallback, useLayoutEffect } from "react";
import { Anchor } from "@ebscois/react-component-library";
import {
  StyledAdditionalDataDiv,
  StyledSpanAdditionalDataText,
  StyledSpanAdditionalDataValue,
  StyledViewAllLink,
} from "./_styled";

const isElementOverflowing = (elementDOM) =>
  elementDOM.scrollWidth - elementDOM.offsetWidth > 1;

const ContentHeaderAdditionalData = ({
  label,
  testId = "additional-data",
  value,
}) => {
  const [isEllipsed, setIsEllipsed] = useState(false);
  const [isViewAllLinkClicked, setIsViewAllLinkClicked] = useState(false);
  const routeElementRef = useRef();

  const combinedValueString = value?.length ? value.join(", ") : "";

  // Hides "View all" link
  const hideViewAll = () => setIsViewAllLinkClicked(true);

  const checkOverflow = useCallback(() => {
    if (!routeElementRef.current || isViewAllLinkClicked) {
      return;
    }
    const isOverflowing = isElementOverflowing(routeElementRef.current);
    setIsEllipsed(isOverflowing);
  }, [isViewAllLinkClicked]);

  useLayoutEffect(() => {
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [checkOverflow]);

  return label && combinedValueString.length > 0 ? (
    <StyledAdditionalDataDiv data-testid={testId}>
      <StyledSpanAdditionalDataText>{label}</StyledSpanAdditionalDataText>
      <StyledSpanAdditionalDataValue
        isViewAllClicked={isViewAllLinkClicked}
        ref={routeElementRef}
      >
        {combinedValueString}
      </StyledSpanAdditionalDataValue>
      {isEllipsed && !isViewAllLinkClicked && (
        <StyledViewAllLink data-testid={`content-${testId}-view-all-link`}>
          <Anchor
            fontSize="sm"
            onClick={(e) => {
              e.preventDefault();
              hideViewAll();
            }}
          >
            View all
          </Anchor>
        </StyledViewAllLink>
      )}
    </StyledAdditionalDataDiv>
  ) : (
    <></>
  );
};

ContentHeaderAdditionalData.displayName = "ContentHeaderAdditionalData";

export default ContentHeaderAdditionalData;
